import React, { createContext, useContext } from 'react';
export function loadConfigFromBootstrap(fallback) {
    return window.config || fallback;
}
export function loadAndMergePatch(base) {
    const patch = window.config || {};
    return {
        ...base,
        ...patch,
    };
}
export function createConfigContext(defaultValue) {
    const configContext = createContext({
        config: defaultValue,
    });
    const { Provider, Consumer } = configContext;
    const useConfig = () => {
        const { config } = useContext(configContext);
        return config;
    };
    const ConfigProvider = ({ config, children }) => (React.createElement(Provider, { value: { config } }, children));
    function withConfig(WrappedComponent) {
        return (props) => (React.createElement(Consumer, null, (context) => (React.createElement(WrappedComponent, { ...props, config: context.config }))));
    }
    return {
        useConfig,
        ConfigProvider,
        withConfig,
        injectConfig: withConfig,
        loadConfigFromBootstrap: () => loadConfigFromBootstrap(defaultValue),
    };
}
//# sourceMappingURL=client.js.map